module.exports = __webpack_public_path__ + "static/media/brujula-pt.eafeedbe.svg";